// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiBox-root MuiBox-root-1"
      >
        <div
          class="MuiContainer-root MuiContainer-maxWidthLg"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column MuiGrid-grid-xs-8"
            >
              <h5
                class="MuiTypography-root MuiTypography-h5"
              >
                Dr Test User
              </h5>
              <div
                class="MuiBox-root MuiBox-root-2"
              >
                <p
                  class="MuiTypography-root MuiTypography-body1"
                  varient="body1"
                >
                  123 address road
                   
                  <br />
                  
                  Some City
                  , 
                  Some Province
                   
                  <br />
                  S0S 1S1
                </p>
              </div>
              <div
                class="MuiBox-root MuiBox-root-3"
              >
                <p
                  class="MuiTypography-root MuiTypography-body1"
                  varient="body1"
                >
                  user@example.com
                   
                  <br />
                  xxx-xxx-xxxx
                </p>
              </div>
              <div
                class="MuiBox-root MuiBox-root-4"
              >
                <h6
                  class="MuiTypography-root MuiTypography-h6"
                  style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
                >
                  Billed To
                </h6>
                <p
                  class="MuiTypography-root MuiTypography-body1"
                  varient="body1"
                >
                  Test Patient
                   
                  <br />
                  123 address road
                   
                  <br />
                  
                  City
                  , 
                  Province
                   
                  <br />
                  S0S 1S1
                   
                  <br />
                  Canada
                </p>
              </div>
            </div>
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column MuiGrid-align-items-xs-flex-end MuiGrid-grid-xs-4"
            >
              <h4
                class="MuiTypography-root MuiTypography-h4"
              >
                Invoice
              </h4>
              <div
                class="MuiBox-root MuiBox-root-5"
              >
                <h6
                  class="MuiTypography-root MuiTypography-h6"
                  style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
                >
                  Invoice Number
                </h6>
                <p
                  class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
                  varient="body1"
                >
                  123
                </p>
              </div>
              <div
                class="MuiBox-root MuiBox-root-6"
              >
                <h6
                  class="MuiTypography-root MuiTypography-h6"
                  style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
                >
                  Date of issue
                </h6>
                <p
                  class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
                  varient="body1"
                >
                  7 Dec 2020
                </p>
              </div>
            </div>
          </div>
          <div
            class="MuiTableContainer-root"
          >
            <table
              aria-label="customized table"
              class="MuiTable-root"
            >
              <thead
                class="MuiTableHead-root"
              >
                <tr
                  class="MuiTableRow-root MuiTableRow-head"
                >
                  <th
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7"
                    scope="col"
                    width="20%"
                  >
                    Date
                  </th>
                  <th
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7"
                    scope="col"
                    width="60%"
                  >
                    Description
                  </th>
                  <th
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7 MuiTableCell-alignRight"
                    scope="col"
                    width="20%"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody
                class="MuiTableBody-root"
              >
                <tr
                  class="MuiTableRow-root WithStyles(ForwardRef(TableRow))-root-9"
                >
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                  >
                    19 Jan 1970
                  </td>
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                  >
                    C12345
                     - 
                    Some record description
                  </td>
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body MuiTableCell-alignRight"
                  >
                    $
                    123.55
                  </td>
                </tr>
                <tr
                  class="MuiTableRow-root WithStyles(ForwardRef(TableRow))-root-9"
                >
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                  >
                    19 Jan 1970
                  </td>
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                  >
                    C12345
                     - 
                    Some record description2
                  </td>
                  <td
                    class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body MuiTableCell-alignRight"
                  >
                    $
                    123.55
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="MuiBox-root MuiBox-root-10"
          >
            <p
              class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
            >
              <span
                style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700; margin-right: 30px;"
              >
                Invoice Total:
              </span>
              <span
                style="margin-right: 7px;"
              >
                 $
                247.10
              </span>
            </p>
          </div>
          <div
            class="MuiBox-root MuiBox-root-11"
          >
            <h6
              class="MuiTypography-root MuiTypography-h6"
              style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
            >
              Terms
            </h6>
            <p
              class="MuiTypography-root MuiTypography-body1"
            >
              Payment must be paid, otherwise nothing happens :P
            </p>
          </div>
          <div
            style="page-break-inside: avoid;"
          >
            <hr
              class="MuiDivider-root"
            />
            <div
              class="MuiBox-root MuiBox-root-12"
            >
              <div
                class="MuiBox-root MuiBox-root-13"
              >
                <p
                  class="MuiTypography-root MuiTypography-body1"
                >
                  How to pay (include this portion with your payment)
                </p>
              </div>
              <div
                class="MuiBox-root MuiBox-root-14"
              >
                <p
                  class="MuiTypography-root MuiTypography-body1"
                  varient="h5"
                >
                  <b>
                    Cheque
                  </b>
                </p>
                <div
                  class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
                >
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3 MuiGrid-grid-lg-2"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-body1"
                      varient="subtitle1"
                    >
                      Make payable to: 
                      <br />
                      Mailing Address: 
                      <br />
                      Invoice #: 
                      <br />
                      Amount:
                    </p>
                  </div>
                  <div
                    class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-lg-8"
                  >
                    <p
                      class="MuiTypography-root MuiTypography-body1"
                      varient="subtitle1"
                    >
                      Dr Test User
                       
                      <br />
                      123 address road
                      , 
                      
                       
                      Some City
                      ,
                       
                      Some Province
                      , 
                      S0S 1S1
                       
                      <br />
                      123
                       
                      <br />
                      $
                      247.10
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiBox-root MuiBox-root-1"
    >
      <div
        class="MuiContainer-root MuiContainer-maxWidthLg"
      >
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
        >
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column MuiGrid-grid-xs-8"
          >
            <h5
              class="MuiTypography-root MuiTypography-h5"
            >
              Dr Test User
            </h5>
            <div
              class="MuiBox-root MuiBox-root-2"
            >
              <p
                class="MuiTypography-root MuiTypography-body1"
                varient="body1"
              >
                123 address road
                 
                <br />
                
                Some City
                , 
                Some Province
                 
                <br />
                S0S 1S1
              </p>
            </div>
            <div
              class="MuiBox-root MuiBox-root-3"
            >
              <p
                class="MuiTypography-root MuiTypography-body1"
                varient="body1"
              >
                user@example.com
                 
                <br />
                xxx-xxx-xxxx
              </p>
            </div>
            <div
              class="MuiBox-root MuiBox-root-4"
            >
              <h6
                class="MuiTypography-root MuiTypography-h6"
                style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
              >
                Billed To
              </h6>
              <p
                class="MuiTypography-root MuiTypography-body1"
                varient="body1"
              >
                Test Patient
                 
                <br />
                123 address road
                 
                <br />
                
                City
                , 
                Province
                 
                <br />
                S0S 1S1
                 
                <br />
                Canada
              </p>
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-direction-xs-column MuiGrid-align-items-xs-flex-end MuiGrid-grid-xs-4"
          >
            <h4
              class="MuiTypography-root MuiTypography-h4"
            >
              Invoice
            </h4>
            <div
              class="MuiBox-root MuiBox-root-5"
            >
              <h6
                class="MuiTypography-root MuiTypography-h6"
                style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
              >
                Invoice Number
              </h6>
              <p
                class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
                varient="body1"
              >
                123
              </p>
            </div>
            <div
              class="MuiBox-root MuiBox-root-6"
            >
              <h6
                class="MuiTypography-root MuiTypography-h6"
                style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
              >
                Date of issue
              </h6>
              <p
                class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
                varient="body1"
              >
                7 Dec 2020
              </p>
            </div>
          </div>
        </div>
        <div
          class="MuiTableContainer-root"
        >
          <table
            aria-label="customized table"
            class="MuiTable-root"
          >
            <thead
              class="MuiTableHead-root"
            >
              <tr
                class="MuiTableRow-root MuiTableRow-head"
              >
                <th
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7"
                  scope="col"
                  width="20%"
                >
                  Date
                </th>
                <th
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7"
                  scope="col"
                  width="60%"
                >
                  Description
                </th>
                <th
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-head WithStyles(ForwardRef(TableCell))-head-7 MuiTableCell-alignRight"
                  scope="col"
                  width="20%"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody
              class="MuiTableBody-root"
            >
              <tr
                class="MuiTableRow-root WithStyles(ForwardRef(TableRow))-root-9"
              >
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                >
                  19 Jan 1970
                </td>
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                >
                  C12345
                   - 
                  Some record description
                </td>
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body MuiTableCell-alignRight"
                >
                  $
                  123.55
                </td>
              </tr>
              <tr
                class="MuiTableRow-root WithStyles(ForwardRef(TableRow))-root-9"
              >
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                >
                  19 Jan 1970
                </td>
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body"
                >
                  C12345
                   - 
                  Some record description2
                </td>
                <td
                  class="MuiTableCell-root WithStyles(ForwardRef(TableCell))-root-8 MuiTableCell-body MuiTableCell-alignRight"
                >
                  $
                  123.55
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="MuiBox-root MuiBox-root-10"
        >
          <p
            class="MuiTypography-root MuiTypography-body1 MuiTypography-alignRight"
          >
            <span
              style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700; margin-right: 30px;"
            >
              Invoice Total:
            </span>
            <span
              style="margin-right: 7px;"
            >
               $
              247.10
            </span>
          </p>
        </div>
        <div
          class="MuiBox-root MuiBox-root-11"
        >
          <h6
            class="MuiTypography-root MuiTypography-h6"
            style="color: rgb(169, 169, 169); text-transform: uppercase; font-size: 14px; font-weight: 700;"
          >
            Terms
          </h6>
          <p
            class="MuiTypography-root MuiTypography-body1"
          >
            Payment must be paid, otherwise nothing happens :P
          </p>
        </div>
        <div
          style="page-break-inside: avoid;"
        >
          <hr
            class="MuiDivider-root"
          />
          <div
            class="MuiBox-root MuiBox-root-12"
          >
            <div
              class="MuiBox-root MuiBox-root-13"
            >
              <p
                class="MuiTypography-root MuiTypography-body1"
              >
                How to pay (include this portion with your payment)
              </p>
            </div>
            <div
              class="MuiBox-root MuiBox-root-14"
            >
              <p
                class="MuiTypography-root MuiTypography-body1"
                varient="h5"
              >
                <b>
                  Cheque
                </b>
              </p>
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
              >
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3 MuiGrid-grid-lg-2"
                >
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                    varient="subtitle1"
                  >
                    Make payable to: 
                    <br />
                    Mailing Address: 
                    <br />
                    Invoice #: 
                    <br />
                    Amount:
                  </p>
                </div>
                <div
                  class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-lg-8"
                >
                  <p
                    class="MuiTypography-root MuiTypography-body1"
                    varient="subtitle1"
                  >
                    Dr Test User
                     
                    <br />
                    123 address road
                    , 
                    
                     
                    Some City
                    ,
                     
                    Some Province
                    , 
                    S0S 1S1
                     
                    <br />
                    123
                     
                    <br />
                    $
                    247.10
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
